// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_bootstrap_dist_js_bootstrap_js","src_shared_css_paf-bootstrap_scss"], () => (__webpack_require__("./src/apps/not-found/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
